var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 12.9531C0.6875 12.9531 0.46875 12.8594 0.28125 12.6719C0.09375 12.4844 0 12.2656 0 12.0156V2.64062C0 2.39062 0.09375 2.17188 0.28125 1.98438C0.46875 1.79688 0.6875 1.70312 0.9375 1.70312H7.26562L6.32812 2.64062H0.9375V12.0156H10.3125V6.57812L11.25 5.64062V12.0156C11.25 12.2656 11.1562 12.4844 10.9688 12.6719C10.7812 12.8594 10.5625 12.9531 10.3125 12.9531H0.9375ZM8.46875 1.82813L9.14062 2.48438L4.6875 6.92188V8.26562H6.01562L10.4844 3.79688L11.1406 4.45313L6.40625 9.20312H3.75V6.54688L8.46875 1.82813ZM11.1406 4.45313L8.46875 1.82813L10.0312 0.265625C10.2083 0.0885418 10.4297 0 10.6953 0C10.9609 0 11.1823 0.09375 11.3594 0.28125L12.6719 1.60938C12.849 1.79688 12.9375 2.01823 12.9375 2.27344C12.9375 2.52865 12.8438 2.74479 12.6562 2.92188L11.1406 4.45313Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/newMessage.dadca99d61073dedfd870ddcbe9e8ee8.svg";
export { ForwardRef as ReactComponent };